import { useEffect, useRef, useState } from 'react';
import { useAppSelector } from '../store';

export function useRocketCoins() {
  const [rocketCoins, setRocketCoins] = useState<number>(0);
  const [rocketCoinsPerHour, setRocketCoinsPerHour] = useState<number>(0);
  const workerRef = useRef<Worker | null>(null);
  const {
    settings: appSettings,
  } = useAppSelector(({ settings }) => settings);
  const { userData } = useAppSelector(
    ({ profile }) => profile,
  );
  useEffect(() => {
    const coinsPerHour = (appSettings?.base_rocket_coins_recovery_per_hour || 0) + (userData?.rocket_coins_recovery_per_hour || 0);
    if (coinsPerHour) {
      setRocketCoinsPerHour(coinsPerHour);
    }
    if (userData?.rocket_coins) {
      setRocketCoins(userData?.rocket_coins);
    }
  }, [userData?.rocket_coins, userData?.rocket_coins_recovery_per_hour, appSettings?.base_rocket_coins_recovery_per_hour]);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (typeof Worker !== 'undefined') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      workerRef.current = new Worker(new URL('../workers/webWorker.ts', import.meta.url));

      workerRef.current.onmessage = (event) => {
        setRocketCoins(event.data);
      };
      const coinsPerHour = (appSettings?.base_rocket_coins_recovery_per_hour || 0) + (userData?.rocket_coins_recovery_per_hour || 0);
      const coinsPerSecond = coinsPerHour / 60 / 60;
      workerRef.current.postMessage({
        coinsPerSecond,
        currentCoins: userData?.rocket_coins,
      });

      return () => workerRef.current?.terminate();
    }
  }, [userData?.rocket_coins, userData?.rocket_coins_recovery_per_hour, appSettings?.base_rocket_coins_recovery_per_hour]);

  return { rocketCoins, rocketCoinsPerHour };
}
